import { MakeCall } from './createMakeCall';
import { Conversation } from './types';

export default (makeCall: MakeCall) => ({
  conversationId,
  file,
  isSensitiveDocument,
}: {
  conversationId: number;
  file: File;
  isSensitiveDocument?: boolean;
}) =>
  makeCall<Conversation>(
    'PUT',
    `/api/v2/conversation/${conversationId}/attachment`,
    {
      data: {
        attachmentFile: file,
        isSensitiveDocument: isSensitiveDocument ? 'true' : undefined,
      },
      headers: {
        'Content-Type': 'multipart/form-data; boundary=%s',
      },
      query: { expand: 'messages' },
    },
  );
